import React, { useState, useRef, useContext, useEffect } from "react";
import Logo from "../Common/Logo";
import Textinput from "../elements/TextInput/TextInput";
import Selectbox from "../elements/SelectBox/SelectBox";
import Textarea from "../elements/TextArea/TextArea";
import Button from "../elements/Button/Button";
import ImageIcon from "../elements/ImageIcon/ImageIcon";
import UploadImageTemp from "../elements/ImageTempUpload/ImageTempUpload";
import { validateEmail } from "../Validation/Validation";
import Notification from "../Notification/Notification";
import { AuthContext } from "../../context/AuthContext";
import CryptoJS from "crypto-js";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import "./CompanyDetail.css";
const CompanyAdd = () => {
  const { token } = useContext(AuthContext);
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [addCompanyNameVal, companyNameFun] = useState("");
  const [companyProfileImage, imageFun] = useState(false);
  const [companyProfileImageName, imageNameFun] = useState(false);
  const [addCompanyFoundVal, foundedValFun] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const companyName = useRef(null);
  const companyEmail = useRef(null);
  const companySizeRef = useRef(null);
  const companyHeadQuater = useRef(null);
  const companyIndustry = useRef(null);
  const companyAddress = useRef(null);
  const companyLocation = useRef(null);
  const companyAbout = useRef(null);
  const companyWebsite = useRef(null);
  const companyFounded = useRef(null);
  const navigate = useNavigate();
  const companySpecialies = useRef(null);
  const [newSpecialty, setNewSpecialty] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [suggestions, setSuggestions] = useState([
    "Talent Acquisition",
    "Full Cycle Recruiting",
    "Recruitment Marketing",
    "Global Talent Acquisition",
    "Employee Retention Strategies",
    "Custom",
  ]);
  const [selectedValue, setSelectedValue] = useState("");
  const [Industryselect, setIndustryValue] = useState("");
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [errors, setErrors] = useState({
    companyName: "",
    companyEmail: "",
    companySize: "",
    companyHeadQuater: "",
    companyIndustry: "",
    companyAddress: "",
    companyWebsite: "",
  });

  const showNotification = (message, type) => {
    //For Notification
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000); // Auto-hide after 3 seconds
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) {
      UploadImageTemp(file);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      UploadImageTemp(file);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    companySizeRef.current.classList.remove("border-red-600");
  };
  const emailOninputFun = () => {
    companyEmail.current.classList.remove("border-red-600");
  };

  const handleIndustryChange = (event) => {
    setIndustryValue(event.target.value);
    companyIndustry.current.classList.remove("border-red-600");
  };

  const Companysize = [
    { id: "", label: "Select Size" },
    { id: "1", label: "Small (1-10 employees)" },
    { id: "2", label: "Small-Medium (11-50 employees)" },
    { id: "3", label: "Medium (51-100 employees)" },
    { id: "4", label: "Medium-Large (101-250 employees)" },
    { id: "5", label: "Large (251-500 employees)" },
    { id: "6", label: "Enterprise (501-1000 employees)" },
    { id: "7", label: "Corporate (1001-5000 employees)" },
    { id: "8", label: "Global Enterprise (5001+ employees)" },
  ];
  const Industry = [
    { id: "", label: "Select Industry" },
    {
      id: "1",
      label: " Information Technology Consulting & Professional Services",
    },
    { id: "2", label: "Finance, Banking & FinTech" },
    { id: "3", label: "Accounting" },
    { id: "4", label: " Agriculture & Forestry" },
    { id: "5", label: "Mining & Extraction" },
    { id: "6", label: "Construction & Infrastructure" },
    { id: "7", label: "Manufacturing" },
    { id: "8", label: "Wholesale & Distribution" },
    { id: "9", label: "Retail & E-Commerce" },
    { id: "10", label: "Transportation & Logistics" },
    { id: "11", label: " Utilities & Energy" },
    { id: "12", label: "Telecommunications" },
    { id: "13", label: "Real Estate & Property" },
    { id: "14", label: " Marketing, Advertising & PR" },
    { id: "15", label: "Media & Entertainment" },
    { id: "16", label: "Hospitality & Travel" },
    { id: "17", label: " Healthcare & Pharmaceuticals" },
    { id: "18", label: "Education & Training" },
    { id: "19", label: "Nonprofit & Social Services" },
    { id: "20", label: " Government & Public Administration" },
    { id: "21", label: "Defense & Aerospace" },
    { id: "22", label: "Environmental & Sustainability" },
    { id: "23", label: "Automotive & Transportation Equipment" },
    { id: "24", label: "Chemical & Petrochemical" },
    { id: "25", label: "Other / Miscellaneous" },
  ];
  const addSpecialty = (specialty) => {
    if (!selectedSpecialties.includes(specialty)) {
      setSelectedSpecialties([...selectedSpecialties, specialty]);
      companySpecialies.current.classList.remove("border-red-600");
    }
  };

  const removeSpecialty = (specialty) => {
    setSelectedSpecialties(
      selectedSpecialties.filter((item) => item !== specialty)
    );
  };
  const handleCustomSpecialty = () => {
    if (newSpecialty && !suggestions.includes(newSpecialty)) {
      setSuggestions([
        ...suggestions.filter((item) => item !== "Custom"),
        newSpecialty,
        "Custom",
      ]);
      setNewSpecialty("");
      setShowInput(false);
    }
  };

  const validatePhoneNo = (e) => {
    //Mobile Number Validation
    const input = e.target.value.replace(/\D/g, "").slice(0, 10);
    companyPhoneNoFun(input);
  };
  const validateName = (e) => {
    //Name Validation only allow sting ,space and dot
    const input = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
    if (input) companyName.current.classList.remove("border-red-600");
    companyNameFun(input);
  };
  const headQuarterOninputFun = () => {
    companyHeadQuater.current.classList.remove("border-red-600");
  };
  const addressOninputFun = () => {
    companyAddress.current.classList.remove("border-red-600");
  };
  const locationOninputFun = () => {
    companyLocation.current.classList.remove("border-red-600");
  };
  const aboutOninputFun = () => {
    companyAbout.current.classList.remove("border-red-600");
  };
  const websiteOninputFun = () => {
    companyWebsite.current.classList.remove("border-red-600");
  };
  const foundedOninputFun = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    foundedValFun(input);
    if (input) companyFounded.current.classList.remove("border-red-600");
  };
  const UploadImageTemp = async (file) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/signUpImageTemp`, {
        method: "POST",
        body: formData, // Automatically sets the correct Content-Type
      });

      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      const result = await response.json();
      console.log("Server Response:", result); // Debug the server response

      if (result?.files?.file?.[0]) {
        imageFun(result.files.file[0]["newFilename"]);
        imageNameFun(result.files.file[0]["originalFilename"]);
      } else {
        console.error("File information not available in the server response");
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsLoading(false);
    }
  };
  // Helper function to validate URL
  const validateURL = (url) => {
    if (!url) return false;
    let testUrl = url.trim();
    // If no protocol, prepend http:// for validation
    if (!/^https?:\/\//i.test(testUrl)) {
      testUrl = "http://" + testUrl;
    }
    try {
      const parsed = new URL(testUrl);
      // Only allow http or https protocols
      if (!/^https?:$/.test(parsed.protocol)) return false;
      // Must have a valid hostname (not just protocol)
      return !!parsed.hostname && parsed.hostname.includes(".");
    } catch (_) {
      return false;
    }
  };
  const addCompanyFun = async () => {
    var emailVal = companyEmail.current.value;
    var sizeVal = companySizeRef.current.value;
    var headquaterVal = companyHeadQuater.current.value || "null";
    var industryVal = companyIndustry.current.value || "null";
    var addressVal = companyAddress.current.value;
    var locationVal = companyLocation.current.value || "null";
    var aboutVal = companyAbout.current.value || "null";
    var websiteVal = companyWebsite.current.value;
    var foundVal = companyFounded.current.value || "0";
    var specialityVal = selectedSpecialties || [];

    // Validation logic
    let newErrors = {
      companyName: "",
      companyEmail: "",
      companySize: "",
      companyHeadQuater: "",
      companyIndustry: "",
      companyAddress: "",
      companyWebsite: "",
    };
    let hasError = false;

    if (!addCompanyNameVal) {
      newErrors.companyName = "Company name is required.";
      hasError = true;
      companyName.current.classList.add("border-red-600");
      companyName.current.focus();
    }
    if (!emailVal) {
      newErrors.companyEmail = "Company email is required.";
      hasError = true;
      companyEmail.current.classList.add("border-red-600");
      if (!hasError) companyEmail.current.focus();
    } else if (!validateEmail(emailVal)) {
      newErrors.companyEmail = "Enter a valid email address.";
      hasError = true;
      companyEmail.current.classList.add("border-red-600");
      if (!hasError) companyEmail.current.focus();
    }
    if (!sizeVal) {
      newErrors.companySize = "Company size is required.";
      hasError = true;
      companySizeRef.current.classList.add("border-red-600");
      if (!hasError) companySizeRef.current.focus();
    }
    if (!addressVal) {
      newErrors.companyAddress = "Company address is required.";
      hasError = true;
      companyAddress.current.classList.add("border-red-600");
      if (!hasError) companyAddress.current.focus();
    }
    if (!websiteVal) {
      newErrors.companyWebsite = "Company website is required.";
      hasError = true;
      companyWebsite.current.classList.add("border-red-600");
      if (!hasError) companyWebsite.current.focus();
    } else if (!validateURL(websiteVal)) {
      newErrors.companyWebsite =
        "Enter a valid website URL (e.g. https://example.com).";
      hasError = true;
      companyWebsite.current.classList.add("border-red-600");
      if (!hasError) companyWebsite.current.focus();
    }
    setErrors(newErrors);
    if (hasError) return;

    const companyData = {
      name: addCompanyNameVal,
      company_email: emailVal,
      location: locationVal,
      size: sizeVal,
      description: "nill",
      head_quarters: headquaterVal,
      url: websiteVal,
      industry: industryVal,
      about: aboutVal,
      specialities: specialityVal,
      founded_year: foundVal,
      lat: companyLocation.current.value.split(",")[0] || "0",
      lang: companyLocation.current.value.split(",")[1] || "0",
      profile: companyProfileImage,
      address: addressVal,
    };
    console.log(companyData, "companyData");
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(companyData),
      process.env.REACT_APP_SECRETKEY
    ).toString();
    const serverURL = process.env.REACT_APP_SERVER_URL;
    var encryptjson = { data: encryptedData };
    setIsLoading(true);
    try {
      const response = await fetch(`${serverURL}/company/addCompany`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(encryptjson),
      });
      console.log("herer");

      if (!response.ok) {
        if (response.status === 409) {
          const errorData = {
            status: "error",
            error: "Company already exists",
          };
          showNotification(errorData.error, errorData.status);
        } else {
          throw new Error("Network response was not ok");
        }
      }
      const data = await response.json();
      const companyData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      console.log("The company data :: ", companyData);
      var notificationStatus = "";
      var notificationContent = "";
      if (data.status) {
        notificationStatus = data.status;
      }
      if (data.message) {
        notificationContent = data.message;
      }
      if (data.error) {
        notificationContent = data.error;
      }
      showNotification(notificationContent, notificationStatus);
      if (response.ok) {
        const encryptedMetadata = localStorage.getItem("metadata");
        if (encryptedMetadata) {
          const decryptedMetadata = JSON.parse(
            CryptoJS.AES.decrypt(
              encryptedMetadata,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );
          if (companyData && companyData.company_id)
            decryptedMetadata["cid"] = companyData.company_id;
          decryptedMetadata["company_name"] = companyData.name;
          const encryptedUpdatedMetadata = CryptoJS.AES.encrypt(
            JSON.stringify(decryptedMetadata),
            process.env.REACT_APP_SECRETKEY
          ).toString();
          localStorage.setItem("metadata", encryptedUpdatedMetadata);
          localStorage.setItem("jobCreationData", JSON.stringify(companyData));
          if (localStorage.getItem("metadata") === encryptedUpdatedMetadata) {
            navigate("/TeamMember", { state: { showNextBtn: true } });
          } else {
            console.error("Failed to set metadata in localStorage");
          }
        }
      } else {
        throw new Error(data.error || "Error");
      }
    } catch (error) {
      console.log("in errro", error);
      if (error.status === 409) {
        showNotification("Company already exists", "error");
        const errorData = { status: "error", error: "Company already exists" };
        showNotification(errorData.error, errorData.status);
      } else {
        console.error("Error uploading file:", error);
      }
      console.error("Error uploading file:", error);
    } finally {
      setIsLoading(false); // Always hide loader after the request
    }
  };
  const UploadIcon = (
    <svg
      className="w-8 h-8 mb-4 text-[#059669] dark:text-gray-400"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 16"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        strokeWidth="2"
        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
      />
    </svg>
  );
  const UploadLabel = (
    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
      <span className=" text-[#059669] mr-1">Click here</span>to upload or drag
      and drop
    </p>
  );
  const serverURL = process.env.REACT_APP_SERVER_URL;
  // console.log(<img src={`${serverURL}/public/images/temp/${companyProfileImage}`} />)
  const UploadIconWithImage = <div>{companyProfileImageName}</div>;

  const fetchSuggestions = async () => {
    return;
    setSuggestions(["Custom"]);
    const encryptedMetadata = localStorage.getItem("metadata");
    let company_id = "";
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      company_id = decryptedMetadata?.cid || "";
    }

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const jsonData = { cid: company_id, type: "Specialities" };
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(jsonData),
      process.env.REACT_APP_SECRETKEY
    ).toString();

    setIsLoading(true);
    try {
      const response = await fetch(`${serverURL}/masters/selectData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({ data: encryptedData }),
      });

      const data = await response.json();

      if (data.status !== "success") {
        showNotification(data.message || "Failed to fetch data.", "error");
        return;
      }

      let decryptedData = data.data;
      if (typeof data.data === "string") {
        try {
          decryptedData = JSON.parse(
            CryptoJS.AES.decrypt(
              data.data,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );
        } catch (decryptionError) {
          showNotification("Failed to decrypt data.", "error");
          return;
        }
      }
      const fetchedSuggestions = decryptedData.map((item) => item.spec_key);
      setSuggestions([...fetchedSuggestions, "Custom"]);
    } catch (error) {
      showNotification("Something went wrong while loading data.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSuggestions();
  }, []);

  // Handler to get current location and set it in the Location URL input
  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          if (companyLocation.current) {
            companyLocation.current.value = `${latitude}, ${longitude}`;
            companyLocation.current.classList.remove("border-red-600");
          }
        },
        (error) => {
          console.log("location fetch error ::", error);
          if (error.code === 1) {
            // Permission denied
            showNotification(
              "Location access denied. Please allow location access in your browser settings and try again.",
              "error"
            );
          } else {
            showNotification("Unable to retrieve your location", "error");
          }
        }
      );
    } else {
      showNotification(
        "Geolocation is not supported by this browser.",
        "error"
      );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: "", type: "" })}
      />
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="flex flex-col items-center">
            <ClipLoader color="#3498db" loading={isLoading} size={50} />
            <span className="text-white mt-4">Company Adding...</span>
          </div>
        </div>
      )}
      <div className="flex flex-col lg:flex-row pb-24">
        {/* Sidebar - Hidden on mobile, visible on desktop */}
        <div className="hidden lg:block lg:w-3/12 pr-2 mr-8 bg-gradient-to-r from-white to-white-50 to-emerald-50">
          <div className="ml-4">
            <Logo />
          </div>

          <p className="ml-8 mt-8 mb-8 text-base lg:text-lg text-black font-medium leading-tight">
            Steps For Profile Registration
          </p>
          <div className="bg-black flex rounded-lg w-10/12 ml-6 h-16 pr-4 pl-2">
            <div className="bg-black pr-2 w-11 ml-2 h-11 mt-2 border-dashed border-2 border-green-500 rounded-full">
              <div className="bg-[#059669] w-1/8 rounded-full ml-1.5 p-2 w-7 h-7 mt-1.5"></div>
            </div>
            <p className="text-white absolute mt-3 pt-0.5 text-md pl-7">1</p>
            <div>
              <p className="text-white mt-2.5 ml-4 text-sm">
                Company Details
                <p className="text-gray-400 text-xs">Step desciption</p>
              </p>
            </div>
          </div>
          <div className="h-10 ml-32 border-l-2 border-green-500"></div>
          <div className="bg-white flex rounded-lg ml-6 w-10/12 h-16 mt-1 pr-4 pl-2">
            <div className="bg-white pr-2 w-11 ml-2 h-11 mt-2">
              <div className="bg-white w-1/8 border-2 border-gray-500 rounded-full ml-1.5 p-2 w-8 h-8 mt-1.5"></div>
            </div>
            <p className="text-black absolute pt-3 text-md pl-6 ml-0.5">2</p>
            <div>
              <p className="text-black mt-2.5 ml-4 text-sm">
                Add Collaborators
                <p className="text-gray-400 text-xs">Step desciption</p>
              </p>
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Progress Indicator */}
        <div className="lg:hidden bg-white shadow-sm p-4 mb-4">
          <div className="flex items-center justify-center space-x-4">
            {/* Step 1 - Company Details (Active) */}
            <div className="flex items-center flex-1">
              <div className="bg-[#059669] w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium">
                1
              </div>
              <div className="ml-2 flex-1">
                <p className="text-sm font-medium text-black mb-2">
                  Company Details
                </p>
                <p className="text-xs text-gray-400">Fill your information</p>
              </div>
            </div>

            {/* Connector Line */}
            <div className="w-8 h-px bg-gray-300 flex-shrink-0"></div>

            {/* Step 2 - Add Collaborators (Inactive) */}
            <div className="flex items-center flex-1">
              <div className="bg-white w-8 h-8 border-2 border-gray-300 rounded-full flex items-center justify-center text-gray-400 text-sm font-medium">
                2
              </div>
              <div className="ml-2 flex-1">
                <p className="text-sm font-medium text-gray-400 mb-2">
                  Add Collaborators
                </p>
                <p className="text-xs text-gray-400">Add team members</p>
              </div>
            </div>
          </div>
        </div>

        {/* LinkedIn Section for Small/Tablet Screens */}
        <div className="lg:hidden mx-2 sm:mx-4 mb-4">
          <div className="p-4 rounded-lg bg-gradient-custom">
            <Button className="linkedin-button flex items-center bg-white w-full justify-center px-3 py-4 rounded-lg shadow-sm h-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2 w-6 h-6 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  d="m19.0413 19.0413h-2.9635v-4.6409c0-1.1067-.0197-2.5313-1.5412-2.5313-1.5435 0-1.7797 1.2057-1.7797 2.4507v4.7211h-2.96337v-9.54349h2.84487v1.30419h.0399c.5792-.99038 1.6602-1.5841 2.8069-1.54152 3.0035 0 3.5573 1.97562 3.5573 4.54582zm-12.59151-10.84845c-.94342 0-1.72009-.77622-1.72009-1.71964s.77631-1.71973 1.71973-1.71973c.94333 0 1.71955.77613 1.71973 1.71937 0 .94324-.77613 1.71991-1.71937 1.72zm1.48169 10.84845h-2.96651v-9.54389h2.96651zm12.58712-17.0398h-17.04282c-.80002-.00903-1.46603.6415-1.47578 1.44152v17.11358c.00939.8004.67531 1.4517 1.47578 1.4431h17.04282c.8024.0101 1.4707-.641 1.4814-1.4431v-17.11475c-.0107-.80171-.6799-1.45216-1.4814-1.4416z"
                  fill="#0a66c2"
                />
              </svg>
              <div className="text-left flex-1">
                <p className="font-medium text-sm text-gray-900 mb-0">
                  Upload From LinkedIn
                </p>
                <p className="text-xs text-gray-500 m-0">
                  To save your information directly
                </p>
              </div>
            </Button>
          </div>
        </div>

        <div className="border-white mt-0 lg:mt-6 mx-2 sm:mx-4 bg-white w-full lg:w-3/4  mb-0 lg:mb-0">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-7/12 p-4 lg:p-6 lg:pr-4">
              <p className="text-lg lg:text-xl text-black font-bold mt-3">
                Company Profile
                <p className="text-xs font-normal text-gray-500 mt-1">
                  Fill in your previous details and let our AI help you find
                  your perfect job!
                </p>
              </p>
              <p className="text-black font-bold text-md mt-4">
                Upload Company Logo
              </p>

              {companyProfileImage ? (
                <div className="relative w-32 h-32 lg:w-40 lg:h-40 mb-4 flex items-center justify-center mx-auto sm:mx-0">
                  <img
                    src={`${process.env.REACT_APP_SERVER_BASE_URL}/images/temp/${companyProfileImage}`}
                    alt="Company Logo"
                    className="object-contain w-full h-full rounded-lg border border-green-200 bg-white"
                  />
                  <button
                    type="button"
                    className="absolute top-1 right-1 bg-white rounded-full p-1 shadow hover:bg-red-100"
                    onClick={() => {
                      imageFun(false);
                      imageNameFun(false);
                    }}
                    aria-label="Remove image"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-5 h-5 text-red-500"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              ) : (
                <div
                  className="flex items-center justify-center w-full"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <ImageIcon
                    OnChange={handleFileChange}
                    svgIcon={UploadIcon}
                    ImageClass="w-full"
                    inputid="dropzone-file"
                    insideLabel={UploadLabel}
                    labelClass="flex flex-col items-center justify-center w-full h-24 lg:h-32 border-2 border-green-200 border-dashed rounded-lg cursor-pointer bg-teal-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                  />
                </div>
              )}

              <Textinput
                InputRef={companyName}
                value={addCompanyNameVal}
                onChange={validateName}
                label="Company Name"
                labelclass="mb-2 mt-4"
                span="*"
                className="border-1 border-gray-200 w-full pt-2.5 pb-2.5 px-3 rounded-lg text-md"
                placeholder="Enter Company Name"
              />
              {errors.companyName && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.companyName}
                </p>
              )}

              <Textinput
                type="email"
                InputRef={companyEmail}
                OnInput={emailOninputFun}
                label="Email"
                labelclass="mb-2"
                span="*"
                className="border-1 border-gray-200 w-full pt-2.5 pb-2.5 px-3 rounded-lg text-md"
                placeholder="Enter Company Email"
              />
              {errors.companyEmail && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.companyEmail}
                </p>
              )}

              <Selectbox
                span="*"
                label="Company Size"
                labelClass="mt-4 mb-2"
                name="exampleSelect"
                value={selectedValue}
                onChange={handleSelectChange}
                list={Companysize}
                className="pt-2 pb-2 px-3 rounded-lg border-gray-200 bg-white text-md w-full"
                InputRef={companySizeRef}
                required
              />
              {errors.companySize && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.companySize}
                </p>
              )}

              <Textinput
                label="Head Quarter"
                OnInput={headQuarterOninputFun}
                InputRef={companyHeadQuater}
                labelclass="mt-4 mb-2"
                className="border-1 border-gray-200 w-full pb-2.5 pt-2.5 px-3 rounded-lg text-md"
                placeholder="Enter Head Quarter"
              />

              <Selectbox
                label="Industry"
                InputRef={companyIndustry}
                labelClass="mt-4 mb-2"
                name="exampleSelect"
                value={Industryselect}
                onChange={handleIndustryChange}
                list={Industry}
                className="pt-2 pb-2 px-3 rounded-lg border-gray-200 bg-white text-md w-full"
                required
              />

              <Textarea
                OnInput={addressOninputFun}
                InputRef={companyAddress}
                label="Address"
                labelClass="mt-4 mb-2"
                span="*"
                placeholder="Enter Address"
                className="min-h-[80px] lg:min-h-[100px] resize-none p-3 border-1 border-gray-200 w-full rounded-lg text-md"
              />
              {errors.companyAddress && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.companyAddress}
                </p>
              )}

              <div className="flex flex-col sm:flex-row w-full gap-2">
                <div className="w-full sm:w-8/12">
                  <Textinput
                    OnInput={locationOninputFun}
                    InputRef={companyLocation}
                    className="w-full p-3 rounded-lg text-md !border-[1px] border-gray-200"
                    labelclass="mt-4"
                    label="Location URL"
                    placeholder="Enter Location URL"
                  />
                </div>
                <div className="flex items-center justify-center sm:mt-8 gap-2">
                  <p className="px-2 py-1 bg-gray-50 text-xs rounded-full text-gray-500 whitespace-nowrap">
                    Or
                  </p>
                  <Button
                    className="!bg-teal-50 text-green-700 border-none font-normal text-xs px-3 py-2 h-10 rounded-lg whitespace-nowrap"
                    onClick={() => {}}
                  >
                    Current Location
                  </Button>
                </div>
              </div>

              <Textarea
                OnInput={aboutOninputFun}
                InputRef={companyAbout}
                label="About"
                placeholder="About Company"
                labelClass="mt-4 mb-2"
                className="min-h-[80px] lg:min-h-[100px] border-1 border-gray-200 w-full p-3 rounded-lg text-md resize-none"
              />

              <Textinput
                OnInput={websiteOninputFun}
                InputRef={companyWebsite}
                label="Company Website"
                className="border-1 border-gray-200 w-full p-3 rounded-lg text-md"
                span="*"
                labelclass="mt-4 mb-2"
                placeholder="Enter Company Website Link"
              />
              {errors.companyWebsite && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.companyWebsite}
                </p>
              )}

              <Textinput
                value={addCompanyFoundVal}
                onChange={foundedOninputFun}
                InputRef={companyFounded}
                label="Founded"
                className="border-1 border-gray-200 w-full p-3 rounded-lg text-md"
                labelclass="mt-4 mb-2"
                placeholder="Founded Year"
              />
              <div>
                <p className="mb-0 font-bold mt-4 mb-2">Specialties</p>
                <div
                  ref={companySpecialies}
                  className="border-[1px] border-gray-200 w-full p-3 rounded-lg flex flex-wrap gap-2 min-h-[50px]"
                >
                  {selectedSpecialties.map((specialty, index) => (
                    <span
                      key={index}
                      className="flex items-center border-1 border-sky-100 bg-sky-50 bg-opacity-50 text-sm text-black px-3 py-1 rounded-lg"
                    >
                      {specialty}
                      <Button
                        onClick={() => removeSpecialty(specialty)}
                        className="ml-2 w-4 font-bold !bg-teal-50 border-none"
                      >
                        x
                      </Button>
                    </span>
                  ))}
                </div>

                <div className="w-full">
                  <p className="text-gray-500 text-sm mb-2 mt-2">
                    Suggestions:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {suggestions.map((suggestion, index) =>
                      suggestion === "Custom" ? (
                        showInput ? (
                          <div
                            key={index}
                            className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto"
                          >
                            <input
                              type="text"
                              value={newSpecialty}
                              onChange={(e) => setNewSpecialty(e.target.value)}
                              className="border-2 border-gray-200 px-3 py-2 rounded-lg text-xs w-full sm:w-auto"
                              placeholder="Add custom specialty"
                              onKeyDown={(e) =>
                                e.key === "Enter" && handleCustomSpecialty()
                              }
                            />
                            <div className="flex gap-2">
                              <button
                                onClick={handleCustomSpecialty}
                                className="px-3 py-2 text-xs bg-[#059669] text-white rounded-md"
                              >
                                Save
                              </button>
                              <button
                                onClick={() => setShowInput(false)}
                                className="px-3 py-2 text-xs text-red-500 rounded-md border border-red-300"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <button
                            key={index}
                            onClick={() => setShowInput(true)}
                            className="px-3 py-2 border-1 bg-white rounded-lg text-xs text-gray-500 border-sky-200 hover:border-teal-700"
                          >
                            Add+
                          </button>
                        )
                      ) : (
                        <button
                          key={index}
                          onClick={() => addSpecialty(suggestion)}
                          className={`px-3 py-2 border-1 rounded-lg text-xs border-sky-200 ${
                            selectedSpecialties.includes(suggestion)
                              ? "border-teal-100 bg-sky-50 text-black hidden"
                              : "border-teal-100 bg-white text-gray-500"
                          } hover:border-teal-400`}
                        >
                          {suggestion}
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Desktop OR divider - Hidden on mobile/tablet */}
            <div className="hidden lg:block p-4 w-1/12 mt-28 relative">
              <div className="relative bg-white">
                <p className="mt-20 absolute pr-2 pt-1 pb-1 pl-2 rounded-full bg-green-50 text-green-600 font-medium z-50">
                  Or
                </p>
              </div>

              <div className="h-48 ml-4 border-l-2 border-gray-200 relative">
                <div className="absolute top-[5rem] left-[-0.165rem] h-8 w-6 bg-white z-40"></div>
              </div>
            </div>

            {/* Mobile OR divider - Hidden since LinkedIn is now at top */}
            <div className="hidden">
              <div className="flex-1 border-t border-gray-200"></div>
              <div className="px-4 py-2 bg-green-50 text-green-600 font-medium rounded-full text-sm">
                Or
              </div>
              <div className="flex-1 border-t border-gray-200"></div>
            </div>

            {/* LinkedIn Section for Large Screens (1024px+) */}
            <div className="hidden lg:block lg:w-4/12 lg:mt-28 p-4 lg:p-6 rounded-lg lg:mr-6 bg-gradient-custom">
              <Button className="linkedin-button flex items-center bg-white mt-4 lg:mt-10 w-full justify-center lg:justify-start px-3 py-4 rounded-lg shadow-sm h-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-2 w-6 h-6 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m19.0413 19.0413h-2.9635v-4.6409c0-1.1067-.0197-2.5313-1.5412-2.5313-1.5435 0-1.7797 1.2057-1.7797 2.4507v4.7211h-2.96337v-9.54349h2.84487v1.30419h.0399c.5792-.99038 1.6602-1.5841 2.8069-1.54152 3.0035 0 3.5573 1.97562 3.5573 4.54582zm-12.59151-10.84845c-.94342 0-1.72009-.77622-1.72009-1.71964s.77631-1.71973 1.71973-1.71973c.94333 0 1.71955.77613 1.71973 1.71937 0 .94324-.77613 1.71991-1.71937 1.72zm1.48169 10.84845h-2.96651v-9.54389h2.96651zm12.58712-17.0398h-17.04282c-.80002-.00903-1.46603.6415-1.47578 1.44152v17.11358c.00939.8004.67531 1.4517 1.47578 1.4431h17.04282c.8024.0101 1.4707-.641 1.4814-1.4431v-17.11475c-.0107-.80171-.6799-1.45216-1.4814-1.4416z"
                    fill="#0a66c2"
                  />
                </svg>
                <div className="text-left flex-1">
                  <p className="font-medium text-sm text-gray-900 mb-0">
                    Upload From LinkedIn
                  </p>
                  <p className="text-xs text-gray-500 m-0">
                    To save your information directly
                  </p>
                </div>
              </Button>
            </div>
          </div>

          {/* Action Bar - Responsive */}
          <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-4 p-4 lg:mr-4 fixed bottom-0 left-0 right-0 lg:relative lg:bottom-auto lg:left-auto lg:right-auto lg:h-20 bg-white">
            <Button
              onClick={addCompanyFun}
              className="w-full sm:w-auto px-6 py-3 sm:px-4 sm:py-2 rounded-lg border-none !bg-[#059669] text-white font-medium"
            >
              Save & Continue
            </Button>
            <Button className="w-full sm:w-auto px-8 py-2 rounded-lg border bg-transparent text-white hidden">
              Skip
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyAdd;
